var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_setup.canLoadList)?_c(_setup.TasksWidget,{ref:"tasksWidget",on:{"tasksChanged":_setup.getAllTasksCount}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }